export const MAX_SESSION_DURATION_MINUTES = 8 * 60;

export const MAX_EVENT_DAYS = 14;

export const COUNTRIES = {
  // European Union Countries
  austria: 'austria',
  belgium: 'belgium',
  bulgaria: 'bulgaria',
  croatia: 'croatia',
  cyprus: 'cyprus',
  czechRepublic: 'czechRepublic',
  denmark: 'denmark',
  estonia: 'estonia',
  finland: 'finland',
  france: 'france',
  germany: 'germany',
  greece: 'greece',
  hungary: 'hungary',
  ireland: 'ireland',
  italy: 'italy',
  latvia: 'latvia',
  lithuania: 'lithuania',
  luxembourg: 'luxembourg',
  malta: 'malta',
  netherlands: 'netherlands',
  poland: 'poland',
  portugal: 'portugal',
  romania: 'romania',
  slovakia: 'slovakia',
  slovenia: 'slovenia',
  spain: 'spain',
  sweden: 'sweden',

  // Other European Countries
  albania: 'albania',
  iceland: 'iceland',
  norway: 'norway',
  switzerland: 'switzerland',
  unitedKingdom: 'unitedKingdom',

  // North America
  canada: 'canada',
  mexico: 'mexico',
  unitedStates: 'unitedStates',

  // Asia
  china: 'china',
  hongKong: 'hongKong',
  india: 'india',
  indonesia: 'indonesia',
  japan: 'japan',
  malaysia: 'malaysia',
  singapore: 'singapore',
  southKorea: 'southKorea',
  taiwan: 'taiwan',
  thailand: 'thailand',
  vietnam: 'vietnam',

  // Oceania
  australia: 'australia',
  newZealand: 'newZealand',

  // South America
  argentina: 'argentina',
  brazil: 'brazil',
  chile: 'chile',
  colombia: 'colombia',

  // Middle East
  israel: 'israel',
  saudiArabia: 'saudiArabia',
  turkey: 'turkey',
  unitedArabEmirates: 'unitedArabEmirates',

  // Africa
  egypt: 'egypt',
  morocco: 'morocco',
  southAfrica: 'southAfrica',
};

export type Country = keyof typeof COUNTRIES;

export const COUNTRY_TO_CODE_MAP: Record<Country, string> = {
  austria: 'AT',
  belgium: 'BE',
  bulgaria: 'BG',
  croatia: 'HR',
  cyprus: 'CY',
  czechRepublic: 'CZ',
  denmark: 'DK',
  estonia: 'EE',
  finland: 'FI',
  france: 'FR',
  germany: 'DE',
  greece: 'GR',
  hungary: 'HU',
  ireland: 'IE',
  italy: 'IT',
  latvia: 'LV',
  lithuania: 'LT',
  luxembourg: 'LU',
  malta: 'MT',
  netherlands: 'NL',
  poland: 'PL',
  portugal: 'PT',
  romania: 'RO',
  slovakia: 'SK',
  slovenia: 'SI',
  spain: 'ES',
  sweden: 'SE',
  albania: 'AL',
  iceland: 'IS',
  norway: 'NO',
  switzerland: 'CH',
  unitedKingdom: 'GB',
  canada: 'CA',
  mexico: 'MX',
  unitedStates: 'US',
  china: 'CN',
  hongKong: 'HK',
  india: 'IN',
  indonesia: 'ID',
  japan: 'JP',
  malaysia: 'MY',
  singapore: 'SG',
  southKorea: 'KR',
  taiwan: 'TW',
  thailand: 'TH',
  vietnam: 'VN',
  australia: 'AU',
  newZealand: 'NZ',
  argentina: 'AR',
  brazil: 'BR',
  chile: 'CL',
  colombia: 'CO',
  israel: 'IL',
  saudiArabia: 'SA',
  turkey: 'TR',
  unitedArabEmirates: 'AE',
  egypt: 'EG',
  morocco: 'MA',
  southAfrica: 'ZA',
};
